var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcoreLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 71.29,
    width: 75,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.46 0H14.54A14.08 14.08 0 0 0 0 14.54v42.2a14.08 14.08 0 0 0 14.54 14.54h45.92A14.08 14.08 0 0 0 75 56.75V45.2H57.9L50.48 58h-26l-13-22.38 13-22.4h26l7.43 12.83H75V14.54A14.08 14.08 0 0 0 60.46 0z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.47 23.5l-7.04 12.14 7.04 12.13h14.06l7.04-12.13-7.04-12.14H30.47z",
    fill: "#ff5200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcoreLogo);
export default __webpack_public_path__ + "static/media/procore_logo.084a88932639116b19568034ce132e7f.svg";
export { ForwardRef as ReactComponent };